export default "<template>\n  <div v-padding:large>\n    <FdPopover>\n      <FdCalendar slot=\"body\" />\n    </FdPopover>\n  </div>\n</template>"